import React from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import CustomCard from '../../CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import { Link } from 'react-router-dom';
import CustomAlert from '../../CustomAlert/CustomAlert';
import LoginReset from '../../../featured/ResetPassword/LoginReset';
import CustomPopOver from '../../CustomPopOver/CustomPopOver';
import CustomAlertContain from '../../CustomAlert/CustomAlertContain';
import styles from './Settings.module.css';
import CustomTextField from '../../CustomTextField/CustomTextField';

type SocialKey =
  | 'customLink'
  | 'facebook_profile_url'
  | 'instagram_profile_url'
  | 'twitter_profile_url'
  | 'linkedin_profile_url';

type LinkPost =
  | { customLink: string }
  | { facebook_profile_url: string }
  | { instagram_profile_url: string }
  | { twitter_profile_url: string }
  | { linkedin_profile_url: string };

type Profile = {
  Address: {
    city: string;
    country: string;
    geocodeAccuracy: string;
    latitude: string;
    longitude: string;
    postalCode: string;
    state: string;
    street: string;
  };
  Email: string;
  MobilePhone: string;
  Name: string;
  Phone: string;
  Role: string;
  SF_Profile_URL: string;
  facebook_profile_url: string;
  instagram_profile_url: string;
  profile_image_url: string;
  twitter_profile_url: string;
  linkedin_profile_url: string;
  customLink: string[];
};

type SettingsProps = {
  handleCloseSettings: () => void;
  openSettingsModal: boolean;
  setOpenSettingsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setLinkField: React.Dispatch<React.SetStateAction<boolean>>;
  clearLink: () => void;
  setSelectedSettings: React.Dispatch<React.SetStateAction<'Profile' | 'Account' | string>>;
  selectedSettings: 'Profile' | 'Account' | string;
  linkInputRef: React.RefObject<HTMLDivElement>;
  profile: Profile;
  profileLoader: boolean;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void> | void;
  openInput: () => void;
  loading: boolean;
  handleRemoveDp: () => Promise<void> | void;
  handleClickLink: (
    event: React.MouseEvent<HTMLDivElement>,
    type: SocialKey,
    edit?: boolean,
    element?: number,
  ) => void;
  linkField: boolean;
  handleLinkBlur: () => void;
  handleLinkChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  link: string;
  invalidLink: boolean;
  didLinkChange: boolean;
  linkLoader: boolean;
  linkPost: LinkPost;
  handleSave: () => Promise<void> | void;
  customLinkIdx: React.MutableRefObject<number | null>;
  linkValue: string;
  setLink: React.Dispatch<React.SetStateAction<string>>;
  setLinkPost: React.Dispatch<React.SetStateAction<LinkPost>>;
  setAnchorElLink: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  anchorElLink: HTMLDivElement | null;
  idLink: 'simple-popover' | undefined;
  handleDeleteCustomLink: () => Promise<void> | void;
  userEmail: string;
  alert: string;
  setAlert: React.Dispatch<React.SetStateAction<string>>;
  handleLinkField: (type: SocialKey, edit?: boolean, element?: number) => void;
};

const Settings = ({
  handleCloseSettings,
  openSettingsModal,
  setLinkField,
  clearLink,
  setOpenSettingsModal,
  setSelectedSettings,
  selectedSettings,
  linkInputRef,
  profile,
  profileLoader,
  handleFileChange,
  openInput,
  loading,
  handleRemoveDp,
  handleClickLink,
  linkField,
  handleLinkBlur,
  handleLinkChange,
  link,
  invalidLink,
  didLinkChange,
  linkLoader,
  linkPost,
  handleSave,
  customLinkIdx,
  linkValue,
  setLink,
  setLinkPost,
  setAnchorElLink,
  anchorElLink,
  idLink,
  handleDeleteCustomLink,
  userEmail,
  alert,
  setAlert,
  handleLinkField,
}: SettingsProps) => {
  const theme = useTheme();

  return (
    <CustomModal handleClose={handleCloseSettings} open={openSettingsModal}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          // overflowY: 'scroll',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',

            backgroundColor: zeplinColor.Neutral1,

            width: '810px',
            // height: '40rem',
            // overflowY: 'scroll',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              // height: '851px',
              // overflowY: 'scroll',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '24px',
              }}
            >
              <Typography variant='responsiveHeading2'>Settings</Typography>
              <img
                src={'/assets/close-icon.svg'}
                width={24}
                height={24}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setOpenSettingsModal(false);
                  setLinkField(false);
                  clearLink();
                }}
              />
            </Box>
            <Divider
              component='div'
              sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
            />
            <Box style={{ display: 'flex', gap: '24px', padding: '24px' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  flex: 1,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: '9px',
                    padding: '16px',
                    borderRadius: '16px',
                    backgroundColor:
                      selectedSettings === 'Profile'
                        ? zeplinColor.BasicBlack
                        : zeplinColor.Neutral1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setSelectedSettings('Profile')}
                >
                  <img
                    src={
                      selectedSettings === 'Profile'
                        ? `/assets/user-selected.svg`
                        : `/assets/profile.svg`
                    }
                    className={styles['settings-icon']}
                    alt='back-icon'
                  />
                  <Typography
                    variant='responsiveBody3'
                    color={
                      selectedSettings === 'Profile' ? zeplinColor.Neutral1 : zeplinColor.BasicBlack
                    }
                  >
                    Profile
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '9px',
                    padding: '16px',
                    borderRadius: '16px',
                    backgroundColor:
                      selectedSettings === 'Account'
                        ? zeplinColor.BasicBlack
                        : zeplinColor.Neutral1,
                    cursor: 'pointer',
                  }}
                  onClick={() => setSelectedSettings('Account')}
                >
                  <img
                    src={
                      selectedSettings === 'Account'
                        ? `/assets/account-selected.svg`
                        : `/assets/settings.svg`
                    }
                    className={styles['settings-icon']}
                    alt='back-icon'
                  />
                  <Typography
                    variant='responsiveBody3'
                    color={
                      selectedSettings === 'Account' ? zeplinColor.Neutral1 : zeplinColor.BasicBlack
                    }
                  >
                    Account
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  flex: 3,
                  // height: '730px',
                  overflowY: 'scroll',
                }}
              >
                {' '}
                <CustomCard
                  styles={{
                    // height: '730px',
                    height: '75vh',
                    backgroundColor: zeplinColor.Neutral1,
                    borderWidth: `1px 1px 1px 1px`,
                    borderStyle: 'solid',
                    borderColor: `${zeplinColor.Neutral5}`,
                    borderRadius: '14px 14px 14px 14px',
                    overflowY: 'scroll',
                  }}
                >
                  {selectedSettings === 'Profile' ? (
                    <Box
                      sx={{ overflowY: 'scroll', height: '100%', position: 'relative' }}
                      ref={linkInputRef}
                    >
                      <Box
                        sx={{
                          position: 'sticky',
                          top: 0,
                          backgroundColor: zeplinColor.Neutral1,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flex: 1,
                            padding: '24px',
                            // width: '100%',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
                            <Box
                              sx={{
                                width: { xs: '80px', xl: '100px' },
                                height: { xs: '80px', xl: '100px' },
                                borderRadius: '14px',
                                //   border: '1px solid black',
                                backgroundColor: !profile?.profile_image_url
                                  ? zeplinColor.Brand1
                                  : 'transparent',
                                display: 'flex',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                alignItems: 'center',
                                position: 'relative',

                                '&:hover > img': { filter: 'blur(30px)' },

                                '&:hover > div': {
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                },
                              }}
                            >
                              {profile?.profile_image_url ? (
                                <img
                                  className={styles['settings-profile-img']}
                                  src={profile?.profile_image_url}
                                  alt='profile-img'
                                  style={{
                                    borderRadius: '14px',
                                    objectFit: 'fill',
                                    filter: profileLoader ? 'blur(30px)' : '',
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant='responsiveDisplay4'
                                  sx={{
                                    color: zeplinColor.Neutral1,
                                    filter: profileLoader ? 'blur(30px)' : '',
                                    '& :hover': {
                                      filter: 'blur(30px)',
                                    },
                                  }}
                                >
                                  {profile?.Name?.split(' ').map((value: any, index: number) =>
                                    profile?.Name &&
                                    (index === 0 || index === profile?.Name?.split(' ').length - 1)
                                      ? value[0]
                                      : '',
                                  )}
                                </Typography>
                              )}
                              {profileLoader ? (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    display: profileLoader ? 'flex' : 'none',
                                    borderRadius: '14px',

                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    // },
                                  }}
                                >
                                  {' '}
                                  <CircularProgress
                                    sx={{ color: zeplinColor.Neutral1 }}
                                    size={'18px'}
                                  />
                                </Box>
                              ) : (
                                ''
                              )}
                              <Box
                                sx={{
                                  position: 'absolute',
                                  width: '100%',
                                  height: '100%',
                                  display: 'none',
                                  borderRadius: '14px',
                                }}
                              >
                                {profileLoader ? (
                                  ''
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        flex: 1,
                                        width: '100%',
                                        backgroundColor: '#00000026',
                                        display: 'flex',
                                        borderRadius: profile?.profile_image_url
                                          ? '14px 14px 0px 0px'
                                          : '14px 14px 14px 14px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                      }}
                                      onClick={openInput}
                                    >
                                      <input
                                        type='file'
                                        accept='image/*'
                                        id='attachment'
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                      />
                                      <Typography
                                        variant='buttonSmall'
                                        color={zeplinColor.Neutral1}
                                      >
                                        Change
                                      </Typography>
                                    </Box>
                                    {profile?.profile_image_url && (
                                      <Box
                                        sx={{
                                          flex: 1,
                                          width: '100%',
                                          backgroundColor: '#0000004D',
                                          display: 'flex',
                                          borderRadius: '0px 0px 14px 14px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          cursor: 'pointer',
                                        }}
                                        onClick={handleRemoveDp}
                                      >
                                        <Typography
                                          variant='buttonSmall'
                                          color={zeplinColor.Neutral1}
                                        >
                                          Delete
                                        </Typography>
                                      </Box>
                                    )}
                                  </>
                                )}
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                // alignItems: 'center',
                                flexDirection: 'column',
                                // justifyContent: 'center',
                                gap: { xs: '10px', xl: '16px' },
                              }}
                            >
                              <Typography
                                sx={{ fontSize: { xs: '30px', xl: '36px' }, fontWeight: '300' }}
                                // color={zeplinColor.Neutral1}
                              >
                                {profile?.Name?.split(' ')[0]}
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                }}
                              >
                                <Chip
                                  label={
                                    <Typography
                                      variant='responsiveLabel1'
                                      color={zeplinColor.Neutral1}
                                      sx={{ display: 'flex', alignItems: 'center' }}
                                    >
                                      {profile?.Role || 'NA'}
                                    </Typography>
                                  }
                                  sx={{
                                    backgroundColor: zeplinColor.BasicBlack,
                                    padding: '5px 12px 5px 12px',
                                    borderRadius: '50px',
                                    // width: '47px',
                                    height: '24px',
                                    '&.MuiChip-root': {
                                      // flex: 1,
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                          <Link
                            to={`${profile?.SF_Profile_URL}`}
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
                          >
                            <CustomCard
                              styles={{
                                borderRadius: '50px',
                                padding: '10px 10px 10px 16px',
                                backgroundColor: zeplinColor.Neutral1,
                                border: `1px solid ${zeplinColor.Neutral6}`,
                                display: 'flex',
                                gap: '8px',
                                // flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                height: '48px',
                              }}
                            >
                              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                                Salesforce
                              </Typography>
                              <img src='/assets/arrow-link.svg' width={20} height={20} />
                            </CustomCard>
                          </Link>
                        </Box>
                        <Divider
                          component='div'
                          sx={{ borderColor: zeplinColor.Neutral5, position: 'sticky' }}
                        />
                      </Box>
                      <Box sx={{ padding: '24px' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: { xs: '22px', xl: '32px' },
                          }}
                        >
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                            <Typography variant='responsiveHeading2'>Personal Details</Typography>
                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Name
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                    {profile?.Name}
                                  </Typography>
                                )}
                              </Box>
                            </Box>

                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Role
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <Box sx={{ flex: 3, display: 'flex', gap: '8px' }}>
                                    <Chip
                                      label={
                                        <Typography
                                          variant='responsiveLabel1'
                                          color={zeplinColor.Neutral1}
                                        >
                                          {profile?.Role}
                                        </Typography>
                                      }
                                      sx={{
                                        backgroundColor: zeplinColor.BasicBlack,
                                        padding: '5px 12px 5px 12px',
                                        borderRadius: '50px',
                                        // width: '47px',
                                        height: '24px',
                                        '&.MuiChip-root': {
                                          // flex: 1,
                                        },
                                      }}
                                    />

                                    {/* <Chip
                                      label={
                                        <Typography variant='label1' color={zeplinColor.Neutral1}>
                                          N/A
                                        </Typography>
                                      }
                                      sx={{
                                        backgroundColor: zeplinColor.BasicBlack,
                                        padding: '5px 12px 5px 12px',
                                        borderRadius: '50px',
                                        // width: '47px',
                                        height: '24px',
                                        '&.MuiChip-root': {
                                          // flex: 1,
                                        },
                                      }}
                                    /> */}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>
                          <Typography variant='responsiveHeading2'>Contact Details</Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Mobile
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                    {profile.MobilePhone}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Phone
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                    {profile?.Phone}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                {/* <img src='/assets/email.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Email
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <a
                                    href={`mailto:${profile?.Email}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                      color: zeplinColor.Brand1,
                                      textDecoration: 'none',
                                      flex: 3,
                                    }}
                                    className={styles['email-link']}
                                  >
                                    {/* <Typography variant='body2' sx={{ flex: 3 }}> */}
                                    {profile?.Email}
                                    {/* </Typography> */}
                                  </a>
                                )}
                              </Box>
                            </Box>

                            <Box sx={{ display: 'flex', gap: '48px' }}>
                              <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                <Typography
                                  variant='responsiveBody2'
                                  color={zeplinColor.Neutral8}
                                  sx={{ flex: 1 }}
                                >
                                  Address
                                </Typography>

                                {loading ? (
                                  <Skeleton
                                    variant='text'
                                    sx={{
                                      fontSize: theme.typography.body2,
                                      flex: 1,
                                      // Optionally adjust other styles here
                                    }}
                                  />
                                ) : (
                                  <Typography
                                    variant='responsiveBody2'
                                    sx={{ flex: 3, textWrap: 'nowrap', whiteSpace: 'nowrap' }}
                                  >
                                    {`${profile?.Address?.street ? profile?.Address?.street : ''}`}
                                    {`${
                                      profile?.Address?.city ? ', ' + profile?.Address?.city : ''
                                    }`}
                                    {`${
                                      profile?.Address?.state ? ', ' + profile?.Address?.state : ''
                                    }`}
                                    {`${
                                      profile?.Address?.country
                                        ? ', ' + profile?.Address?.country
                                        : ''
                                    }`}
                                    {`${
                                      profile?.Address?.postalCode
                                        ? ', ' + profile?.Address?.postalCode
                                        : ''
                                    }`}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>

                          <Typography variant='responsiveHeading2'>Links</Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: { xs: '20px', xl: '24px' },
                            }}
                          >
                            <Box sx={{ display: 'flex', gap: { xs: '12px', xl: '16px' } }}>
                              {/* <Link
                                  to={`${profile?.facebook_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                > */}

                              <Box
                                sx={{
                                  position: 'relative',
                                  '&:hover > .hover-image': {
                                    display: 'flex', // Show the second image on hover
                                  },
                                }}
                                onClick={(e) => handleClickLink(e, 'linkedin_profile_url')}
                              >
                                <Link
                                  to={`${profile?.linkedin_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{
                                    color: zeplinColor.Neutral1,
                                    textDecoration: 'none',
                                  }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                >
                                  <img
                                    className={styles['link-icon']}
                                    src={'/assets/linkedin-link.png'}
                                    alt='link'
                                    style={{ objectFit: 'fill', cursor: 'pointer' }}
                                    // onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                                  />
                                </Link>
                                <Box
                                  className='hover-image'
                                  sx={{
                                    position: 'absolute',
                                    top: { xs: '-0.4rem', xl: '-0.6rem' },
                                    right: { xs: '-0.6rem', xl: '-1rem' },
                                    display: 'none',
                                    // '&:hover': {
                                    //   display: 'none', // Show the second image on hover
                                    // },
                                  }}
                                >
                                  <img
                                    className={styles['edit-icon']}
                                    src={'/assets/edit-link.png'}
                                    alt='option'
                                    style={{
                                      objectFit: 'fill',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                              {/* </Link> */}
                              <Box
                                sx={{
                                  position: 'relative',
                                  '&:hover > .hover-image': {
                                    display: 'flex', // Show the second image on hover
                                  },
                                }}
                                onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                              >
                                <Link
                                  to={`${profile?.instagram_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{
                                    color: zeplinColor.Neutral1,
                                    textDecoration: 'none',
                                  }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                >
                                  <img
                                    className={styles['link-icon']}
                                    src={'/assets/instagram-link.png'}
                                    alt='link'
                                    style={{ objectFit: 'fill', cursor: 'pointer' }}
                                  />
                                </Link>
                                <Box
                                  className='hover-image'
                                  sx={{
                                    position: 'absolute',
                                    top: { xs: '-0.4rem', xl: '-0.6rem' },
                                    right: { xs: '-0.6rem', xl: '-1rem' },
                                    display: 'none',
                                    // '&:hover': {
                                    //   display: 'none', // Show the second image on hover
                                    // },
                                  }}
                                  // onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                                >
                                  <img
                                    className={styles['edit-icon']}
                                    src={'/assets/edit-link.png'}
                                    alt='option'
                                    style={{
                                      objectFit: 'fill',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  position: 'relative',
                                  '&:hover > .hover-image': {
                                    display: 'flex', // Show the second image on hover
                                  },
                                }}
                                onClick={(e) => handleClickLink(e, 'twitter_profile_url')}
                              >
                                <Link
                                  to={`${profile?.twitter_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{
                                    color: zeplinColor.Neutral1,
                                    textDecoration: 'none',
                                  }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                >
                                  <img
                                    className={styles['link-icon']}
                                    src={'/assets/x-link.png'}
                                    alt='link'
                                    style={{ objectFit: 'fill', cursor: 'pointer' }}
                                  />
                                </Link>
                                <Box
                                  className='hover-image'
                                  sx={{
                                    position: 'absolute',
                                    top: { xs: '-0.4rem', xl: '-0.6rem' },
                                    right: { xs: '-0.6rem', xl: '-1rem' },
                                    display: 'none',
                                    // '&:hover': {
                                    //   display: 'none', // Show the second image on hover
                                    // },
                                  }}
                                >
                                  <img
                                    className={styles['edit-icon']}
                                    src={'/assets/edit-link.png'}
                                    alt='option'
                                    style={{
                                      objectFit: 'fill',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  position: 'relative',
                                  '&:hover > .hover-image': {
                                    display: 'flex', // Show the second image on hover
                                  },
                                }}
                                onClick={(e) => handleClickLink(e, 'facebook_profile_url')}
                              >
                                <Link
                                  to={`${profile?.facebook_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{
                                    color: zeplinColor.Neutral1,
                                    textDecoration: 'none',
                                  }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                >
                                  <img
                                    className={styles['link-icon']}
                                    src={'/assets/facebook-link.png'}
                                    alt='link'
                                    style={{ objectFit: 'fill', cursor: 'pointer' }}
                                    // onClick={(e) => handleClickLink(e, 'facebook_profile_url')}
                                  />
                                </Link>
                                <Box
                                  className='hover-image'
                                  sx={{
                                    position: 'absolute',
                                    top: { xs: '-0.4rem', xl: '-0.6rem' },
                                    right: { xs: '-0.6rem', xl: '-1rem' },
                                    display: 'none',
                                    // '&:hover': {
                                    //   display: 'none', // Show the second image on hover
                                    // },
                                  }}
                                >
                                  <img
                                    className={styles['edit-icon']}
                                    src={'/assets/edit-link.png'}
                                    alt='option'
                                    style={{
                                      objectFit: 'fill',
                                      cursor: 'pointer',
                                    }}
                                  />
                                </Box>
                              </Box>
                              {Array.isArray(profile?.customLink) && profile?.customLink?.length
                                ? profile?.customLink?.map((val: any, ind: any) => (
                                    <Box
                                      sx={{
                                        position: 'relative',
                                        '&:hover > .hover-image': {
                                          display: 'flex', // Show the second image on hover
                                        },
                                      }}
                                      onClick={(e) => handleClickLink(e, 'customLink', true, ind)}
                                    >
                                      <Link
                                        to={`${val}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        style={{
                                          color: zeplinColor.Neutral1,
                                          textDecoration: 'none',
                                        }}
                                        onClick={(e) =>
                                          !profile?.facebook_profile_url && e.preventDefault()
                                        }
                                      >
                                        <Box
                                          sx={{
                                            width: { xs: '26px', xl: '32px' },
                                            height: { xs: '26px', xl: '32px' },
                                            borderRadius: '8px',
                                            padding: '7px',
                                            border: `1px solid none`,
                                            backgroundColor: zeplinColor.Brand1,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                          }}
                                          // onClick={(e) =>
                                          //   handleClickLink(e, 'customLink', true, ind)
                                          // }
                                        >
                                          <img
                                            className={styles['settings-icon']}
                                            src={'/assets/custom-link.svg'}
                                            alt='link'
                                            style={{ objectFit: 'fill' }}
                                          />
                                        </Box>
                                      </Link>
                                      <Box
                                        className='hover-image'
                                        sx={{
                                          position: 'absolute',
                                          top: { xs: '-0.4rem', xl: '-0.6rem' },
                                          right: { xs: '-0.6rem', xl: '-1rem' },
                                          display: 'none',
                                          // '&:hover': {
                                          //   display: 'none', // Show the second image on hover
                                          // },
                                        }}
                                      >
                                        <img
                                          className={styles['edit-link']}
                                          src={'/assets/edit-link.png'}
                                          alt='option'
                                          style={{
                                            objectFit: 'fill',
                                            cursor: 'pointer',
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  ))
                                : ''}
                              <Box
                                sx={{
                                  width: { xs: '28px', xl: '32px' },
                                  height: { xs: '28px', xl: '32px' },
                                  borderRadius: '8px',
                                  padding: '7px',
                                  border: `1px solid ${zeplinColor.Neutral6}`,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  handleLinkField('customLink', false);
                                  setLinkField((prev: any) => !prev);
                                  if (linkField) {
                                    setLink('');
                                    setLinkPost({ customLink: '' });
                                  }
                                  // setTimeout(() => {
                                  //   linkInputRef?.current?.scrollIntoView({
                                  //     behavior: 'smooth',
                                  //     block: 'end',
                                  //   });
                                  // }, 0);
                                  setTimeout(() => {
                                    if (linkInputRef?.current) {
                                      linkInputRef.current.scrollTop =
                                        linkInputRef.current.scrollHeight; // Scroll to the bottom
                                    }
                                  }, 0);
                                }}
                              >
                                <img
                                  width={'12px'}
                                  height={'12px'}
                                  src={'/assets/add.svg'}
                                  alt='link'
                                  style={{ objectFit: 'fill' }}
                                />
                              </Box>
                            </Box>
                            {linkField && (
                              <Box
                                sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                                // ref={linkInputRef}
                              >
                                <CustomTextField
                                  style={{ width: '100%' }}
                                  onBlur={handleLinkBlur}
                                  onChange={handleLinkChange}
                                  name='Link'
                                  text={link}
                                  error={
                                    invalidLink &&
                                    didLinkChange &&
                                    !linkLoader &&
                                    link &&
                                    linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
                                      ? 'Please enter valid link'
                                      : ''
                                  }
                                  label={'Link'}
                                  type='text'
                                  tabindex={1}
                                  close={link ? true : false}
                                  handleClear={() => {
                                    clearLink();
                                  }}
                                  // required
                                />
                                <Box
                                  sx={{
                                    display: 'flex',

                                    gap: '16px',
                                  }}
                                >
                                  <Box
                                    onClick={() => {
                                      !linkLoader && handleSave();
                                    }}
                                  >
                                    <CustomCard
                                      styles={{
                                        borderRadius: '14px',
                                        padding: { xs: '10px 28px', xl: '14px 32px' },
                                        backgroundColor:
                                          (link &&
                                            !invalidLink &&
                                            !linkLoader &&
                                            ((customLinkIdx?.current === null &&
                                              linkValue !==
                                                profile[
                                                  Object.keys(linkPost)[0] as keyof typeof profile
                                                ]) ||
                                              (customLinkIdx?.current !== null &&
                                                linkValue !==
                                                  profile?.customLink[customLinkIdx?.current]))) ||
                                          (linkPost[
                                            Object.keys(linkPost)[0] as keyof typeof linkPost
                                          ] &&
                                            !linkLoader &&
                                            ((customLinkIdx?.current === null &&
                                              linkValue !==
                                                profile[
                                                  Object.keys(linkPost)[0] as keyof typeof profile
                                                ]) ||
                                              (customLinkIdx?.current !== null &&
                                                linkValue !==
                                                  profile?.customLink[customLinkIdx?.current])))
                                            ? zeplinColor.Brand1
                                            : zeplinColor.Neutral5,
                                        cursor: 'pointer',

                                        // border: `1px solid ${zeplinColor.BasicBlack}`,
                                        // width: '312px',
                                        // height: '183px',

                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        // justifyContent: 'space-between',
                                      }}
                                      aria-role='button'
                                      aria-disable={loading}
                                    >
                                      <Typography
                                        variant='responsiveButtonMedium'
                                        color={
                                          (link &&
                                            !invalidLink &&
                                            !linkLoader &&
                                            ((customLinkIdx?.current === null &&
                                              linkValue !==
                                                profile[
                                                  Object.keys(linkPost)[0] as keyof typeof profile
                                                ]) ||
                                              (customLinkIdx?.current !== null &&
                                                linkValue !==
                                                  profile?.customLink[customLinkIdx?.current]))) ||
                                          (linkPost[
                                            Object.keys(linkPost)[0] as keyof typeof linkPost
                                          ] &&
                                            !linkLoader &&
                                            ((customLinkIdx?.current === null &&
                                              linkValue !==
                                                profile[
                                                  Object.keys(linkPost)[0] as keyof typeof profile
                                                ]) ||
                                              (customLinkIdx?.current !== null &&
                                                linkValue !==
                                                  profile?.customLink[customLinkIdx?.current])))
                                            ? zeplinColor.Neutral1
                                            : zeplinColor.Neutral8
                                        }
                                        sx={{ whiteSpace: 'nowrap' }}
                                      >
                                        {linkLoader ? 'Saving link' : 'Save'}
                                      </Typography>
                                    </CustomCard>
                                  </Box>
                                  <Box
                                    onClick={() => {
                                      setLinkField(false);
                                      setLink('');
                                      setLinkPost({ customLink: '' });
                                      clearLink();
                                    }}
                                  >
                                    <CustomCard
                                      styles={{
                                        borderRadius: '14px',
                                        padding: { xs: '10px 28px', xl: '14px 32px' },
                                        backgroundColor: zeplinColor.Neutral1,
                                        border: `1px solid ${zeplinColor.BasicBlack}`,
                                        cursor: 'pointer',
                                        // width: '312px',
                                        // height: '183px',

                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        // justifyContent: 'space-between',
                                      }}
                                      aria-role='button'
                                      aria-disable={loading}
                                    >
                                      <Typography
                                        variant='responsiveButtonMedium'
                                        color={zeplinColor.BasicBlack}
                                      >
                                        Cancel
                                      </Typography>
                                    </CustomCard>
                                  </Box>
                                </Box>
                              </Box>
                            )}
                          </Box>
                          <CustomPopOver
                            setAnchorEl={setAnchorElLink}
                            anchorEl={anchorElLink}
                            id={idLink}
                            sx={{
                              borderRadius: '14px',
                              boxShadow: 'rgba(0, 0, 0, 0.15)',
                              marginTop: '0.1rem',
                              marginRight: '0rem',

                              // padding: '16px',
                              // marginLeft: '-4rem',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                // height: '84px',
                                // width: '119px',
                                padding: '16px',
                                gap: '16px',
                              }}
                            >
                              <a
                                href={`${
                                  linkValue?.startsWith('http://') ||
                                  linkValue?.startsWith('https://')
                                    ? ''
                                    : 'https://'
                                }${linkValue}`}
                                target='_blank'
                                rel='noopener noreferrer'
                                style={{
                                  textDecoration: 'none',
                                  display: 'flex',
                                  gap: '9px',
                                  cursor: !linkPost[
                                    Object.keys(linkPost)[0] as keyof typeof linkPost
                                  ]
                                    ? 'auto'
                                    : 'pointer',
                                }}
                                onClick={(e) =>
                                  !linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost] &&
                                  e.preventDefault()
                                }
                              >
                                <img src={'/assets/eye-open.svg'} width={18} height={18} />
                                <Typography
                                  variant='body3'
                                  color={
                                    !linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
                                      ? zeplinColor?.Neutral8
                                      : zeplinColor.BasicBlack
                                  }
                                >
                                  Open Link
                                </Typography>
                              </a>
                              <Box
                                sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                                onClick={() => {
                                  setLinkField(true);
                                  // setTimeout(() => {
                                  //   linkInputRef.current?.scrollIntoView({
                                  //     behavior: 'smooth',
                                  //     block: 'end',
                                  //   });
                                  // }, 0);
                                  setTimeout(() => {
                                    if (linkInputRef?.current) {
                                      linkInputRef.current.scrollTop =
                                        linkInputRef.current.scrollHeight; // Scroll to the bottom
                                    }
                                  }, 0);
                                  setAnchorElLink(null);
                                }}
                              >
                                <img src={'/assets/edit.svg'} width={18} height={18} />
                                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                                  Edit Link
                                </Typography>
                              </Box>
                              {customLinkIdx?.current != null && (
                                <Box
                                  sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                                  onClick={() => {
                                    handleDeleteCustomLink();
                                  }}
                                >
                                  <img src={'/assets/delete.svg'} width={18} height={18} />
                                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                                    Delete Link
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          </CustomPopOver>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <LoginReset user={userEmail} />
                  )}
                </CustomCard>
              </Box>
            </Box>
          </Box>
          <CustomAlert
            open={alert ? true : false}
            handleClose={() => {
              setAlert('');
            }}
            message={
              <CustomAlertContain
                alert={alert}
                error={alert?.includes('successfully') ? false : true}
                alertIcon={
                  !alert || alert?.includes('successfully') ? (
                    <img src='/assets/checkmark-green.png' width={24} height={24} />
                  ) : (
                    <img src='/assets/error.svg' width={24} height={24} />
                  )
                }
              />
            }
            error={alert && !alert?.includes('successfully') ? true : false}
          />
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default Settings;
